import { Link } from 'react-router-dom';
import qrCode from '../assets/qr-code.png';
import './CTA.css';

export default function CTA() {
  return (
    <section className="cta" id="feedback">
      <div className="container">
        <div className="cta__box">
          <div className="cta__deco cta__deco--lines">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="cta__deco-line" />
            ))}
          </div>
          <div className="cta__deco cta__deco--hole cta__deco--hole-1" />
          <div className="cta__deco cta__deco--hole cta__deco--hole-2" />
          <div className="cta__deco cta__deco--circle" />

          <div className="cta__content">
            <div className="cta__tag">Başlamaya Hazır mısın?</div>
            <h2 className="cta__title">
              Daha iyi çalışma materyalleri keşfetmeye hazır mısın?
            </h2>
            <p className="cta__subtitle">
              NoteSwapp'ı keşfet ve daha organize bir öğrenci not paylaşım topluluğunun parçası ol.
            </p>
            <div className="cta__actions">
              <a href="#about" className="cta__btn-primary">
                Daha Fazla Bilgi
              </a>
              <Link to="/feedback" className="cta__btn-secondary">
                Geri Bildirim Gönder
              </Link>
            </div>

            <div className="cta__qr-badge">
              <img src={qrCode} alt="NoteSwapp QR kodu" className="cta__qr-img" />
              <span>NoteSwapp'i İndir!</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
